// Actiondan gelen datalar ile stateler güncellenecek
export const customerLoading = (state, payload) => {
    state.loading = payload
}

export const customerStatusNull = (state, payload) => {
    state.customerStatus = {}
}

export const saveCustomer = (state, payload) => {
    state.customerStatus = payload.returnData
    state.customerData = payload.sendData
}

export const setCustomer = (state, payload) => {
    state.customerStatus = payload
    if(payload.data){
        state.customerData = payload.data  
    }
}

export const setCustomerAddress = (state, payload) => {
    state.customerAddressInfo = payload
    if(payload.data){
        state.customerAddressData = payload.data
    }
}


export const listCustomer = (state, payload) => {
    if(payload && payload.data){
        state.customers = payload.data
        state.customerPageInfo = payload.list_info

    }else{
        state.customers = []
    }
    //state.customerStatus = payload
}

export const actionStatus = (state, payload) => {
    state.customerStatus = payload
}

export const setCustomerContact = (state, payload) => {
    state.customerContactInfo = payload
    if(payload.data){
        state.customerContactData = payload.data
    }
}

export const setCustomerSubscriptions = (state, payload) => {
    state.customerSubscriptions = payload.data
}

export const setCustomerSubInfo = (state, payload) => {
    state.customerSubsInfo = payload
    
}
export const setCustomerCompany = (state, payload) => {
    state.customerCompanyInfo = payload
    if(payload.data){
        state.customerCompanyData = payload.data
    }
}

export const setCustomerProducts = (state, payload) => {
    state.customerProducts = payload.data ? payload.data : []
}

export const setApprovalHistory = (state, payload) => {
    state.approvalHistory = payload.data ? payload.data : []
}






// WEBPACK FOOTER //
// ./src/store/modules/Alarmsis/Customer/Mutaions.js